import { createTV } from 'tailwind-variants';

// twMerge classifies custom-scale utilities such as `border-b400` as colours and would drop the
// real colour class next to them, so recipes concatenate classes without merging.
export const tv = createTV({ twMerge: false });
